import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/Login/Index.vue"),
  },
  {
    path: "/",
    name: "Home",
    component: () => import("../views/Home/Index.vue"),
    children: [
      {
        path: "/",
        name: "Main",
        component: () => import("../views/Home/Main.vue"),
        meta: {
          title: "首页",
        },
      },
      {
        path: "/editpass",
        name: "EditPass",
        component: () => import("../views/Home/EditPass.vue"),
        meta: {
          title: "修改密码",
        },
      },
      {
        path: "/employee",
        name: "Employee",
        component: () => import("../views/Employee/List.vue"),
        meta: {
          title: "员工花名册",
        },
      },
      {
        path: "/subaccount",
        name: "Subaccount",
        component: () => import("../views/Subaccount/List.vue"),
        meta: {
          title: "子账户",
        },
      },
      {
        path: "/payroll",
        name: "Payroll",
        component: () => import("../views/Payroll/List.vue"),
        meta: {
          title: "工资表",
        },
      },
      {
        path: "/bankreceived",
        name: "BankReceived",
        component: () => import("../views/BankReceived/List.vue"),
        meta: {
          title: "转款记录",
        },
      },
      {
        path: "/invoice",
        name: "Invoice",
        component: () => import("../views/Invoice/List.vue"),
        meta: {
          title: "开票记录",
        },
      },
      {
        path: "/template",
        name: "SalaryTemplate",
        component: () => import("../views/SalaryTemplate/Index.vue"),
        meta: {
          title: "模板管理",
        },
      },
      {
        path: "/info",
        name: "Info",
        component: () => import("../views/Info/Index.vue"),
        meta: {
          title: "企业信息",
        },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
